import script from "./CourtEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtEdit.vue?vue&type=script&setup=true&lang=js"

import "./CourtEdit.vue?vue&type=style&index=0&id=f793136a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f793136a"]])

export default __exports__